<script lang="ts">
  import type { Finnpos } from "./types";
  import { comprehensive, coordinate, positions } from "./stores";

  import Header from "./Header.svelte";
  import Map from "./Map.svelte";
  import Modal from "./Modal.svelte";
  import Sidebar from "./Sidebar.svelte";

  const fetchData = async (comprehensive: boolean, coordinate: [string, string]) => {
    const [x, y] = coordinate;
    if (x === "" || y === "") {
      return;
    }

    loading = true;

    const urlSearchParams: URLSearchParams = new URLSearchParams();
    urlSearchParams.set("firstInput", x);
    urlSearchParams.set("secondInput", y);
    urlSearchParams.set("comprehensive", comprehensive.toString());

    const url: URL = new URL("/positions", "https://finnposisjon.dev.geonorge.no");
    url.search = urlSearchParams.toString();

    const response: Response = await fetch(url.toString());
    const data: Finnpos = await response.json();

    positions.set(data.positions);
    loading = false;
  };

  let loading: boolean = false;

  $: fetchData($comprehensive, $coordinate);
</script>

<Map />
<Header />
<Sidebar />
<Modal />
{#if loading}
  <div class="loader">
    <div class="circle alpha" />
    <div class="circle omega" />
  </div>
{/if}

<style>
  .loader {
    background: rgba(255, 255, 255, 0.25);
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
  }
  .circle {
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-name: loader;
    animation-timing-function: linear;
    border-style: solid;
    border-width: 10px;
    border-radius: 100px;
    height: 20px;
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
  }
  .circle.alpha {
    border-color: #0058a3;
  }
  .circle.omega {
    animation-delay: 1s;
    border-color: #ccc;
  }
  @keyframes loader {
    0% {
      height: 20px;
      opacity: 0;
      width: 20px;
    }
    25% {
      opacity: 1;
    }
    75% {
      opacity: 1;
    }
    100% {
      height: 200px;
      opacity: 0;
      width: 200px;
    }
  }
</style>
